<div class="google {{theme.type}}" tabindex="-1" id="googleBtn"></div>
